"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.XHRTrustedChallengePlugin = exports.TrustedChallengeSecurityHeaderType = void 0;
const web_ui_framework_1 = require("@gruposantander/web-ui-framework");
const authoriser_helper_1 = require("../../../security/authoriser/helpers/authoriser.helper");
const types_1 = require("../../../security/authoriser/types");
var TrustedChallengeSecurityHeaderType;
(function (TrustedChallengeSecurityHeaderType) {
    TrustedChallengeSecurityHeaderType["TRUSTED_CONFIRMATION_REQUIRED"] = "Trusted-Confirmation-Required";
    TrustedChallengeSecurityHeaderType["AUTHORIZATION_REQUIRED"] = "Authorization-Required";
    TrustedChallengeSecurityHeaderType["SIGNATURE_KEY_EXPIRED"] = "signature-key-expired";
    TrustedChallengeSecurityHeaderType["LIMIT_EXCEEDED"] = "limit-exceeded";
})(TrustedChallengeSecurityHeaderType || (exports.TrustedChallengeSecurityHeaderType = TrustedChallengeSecurityHeaderType = {}));
class XHRTrustedChallengePlugin {
    constructor(authoriser) {
        this.name = this.constructor.name;
        this.authoriser = authoriser;
    }
    async handleResponse(response) {
        const { httpStatus, responseHeaders, data } = response.data;
        const challengeResponseData = data;
        const { url } = response.reference;
        const securityHeader = responseHeaders['x-security'];
        const initializeIfChallengeIsInApp = () => {
            if (securityHeader === TrustedChallengeSecurityHeaderType.TRUSTED_CONFIRMATION_REQUIRED) {
                const { biometricId, accessToken, progressId } = challengeResponseData;
                this.authoriser.initializeAuthoriser({
                    biometricId,
                    accessToken,
                    progressId,
                    nextChallengeType: types_1.ChallengeType.TRUSTED_CONFIRMATION_LOGIN,
                }, response.calls.originCall);
            }
        };
        const initializeIfChallengeIsOtp = () => {
            if (securityHeader === TrustedChallengeSecurityHeaderType.AUTHORIZATION_REQUIRED) {
                const modifiedData = { ...challengeResponseData, nextChallengeType: types_1.ChallengeType.OTP_LOGIN };
                this.authoriser.initializeAuthoriser(modifiedData, response.calls.originCall, url);
            }
        };
        const setAuthoriserBlocked = () => {
            if (securityHeader === TrustedChallengeSecurityHeaderType.SIGNATURE_KEY_EXPIRED ||
                securityHeader === TrustedChallengeSecurityHeaderType.LIMIT_EXCEEDED) {
                if (!this.authoriser.state.isStarted) {
                    this.authoriser.updateState({ isStarted: true });
                }
                this.authoriser.fail(true);
            }
        };
        return new Promise(resolve => {
            switch (httpStatus) {
                case web_ui_framework_1.HTTP_STATUS.SUCCESS:
                    initializeIfChallengeIsInApp();
                    break;
                case web_ui_framework_1.HTTP_STATUS.FORBIDDEN:
                case web_ui_framework_1.HTTP_STATUS.FORBIDDEN_AUTHORISER:
                    initializeIfChallengeIsOtp();
                    break;
                case web_ui_framework_1.HTTP_STATUS.PRECONDITION_FAILED:
                    setAuthoriserBlocked();
                    break;
                default:
                    break;
            }
            resolve(response);
        });
    }
    async handleRequest(request) {
        const newRequest = (0, authoriser_helper_1.hashRequestURL)(request.url);
        const originalRequest = this.authoriser.requestId;
        const progressId = this.authoriser?.progressId ?? '';
        if (newRequest === originalRequest) {
            request.headers = {
                ...request.headers,
                progressId,
            };
        }
        return Promise.resolve(request);
    }
}
exports.XHRTrustedChallengePlugin = XHRTrustedChallengePlugin;
//# sourceMappingURL=xhrTrustedChallengePlugin.js.map